<template>
<b-container
  class="d-flex bg-white section"
  fluid
  >
  <b-row class="m-auto text-center justify-content-center">
    <b-col class="p-0">
      
      <b-container class="p-3 p-lg-5" fluid ref="silo">
	<b-row>
	  <b-col>
	    <b-jumbotron class="bg-white p-3 p-md-5 text-center">
	      <h1 class="px-md-5">
		<slot name="header">Are your files locked up into one app, by one organization?</slot>
	      </h1>
	      <b-container class="pb-md-5">
		<b-row>
		  <b-col
		    cols="12"
		    sm="7"
		    class="order-2 order-sm-1"
		    >
		    <div class="pt-5 d-inline-block">
		      <div class="text-left">
			<div class="d-flex mb-2">
			  <font-awesome-icon :icon="faCheck" class="mr-2 mt-1 mb-auto" :style="{ color: checkColor }" />
			  <slot name="bullet-1">
			    <p class="mb-0">Is it difficult to move your files to another app?</p>
			  </slot>
			</div>
			<div class="d-flex mb-2">
			  <font-awesome-icon :icon="faCheck" class="mr-2 mt-1 mb-auto" :style="{ color: checkColor }" />
			  <slot name="bullet-2">
			    <p class="mb-0">Are your files siloed into one organization's app?</p>
			  </slot>
			</div>
			<div class="d-flex mb-2">
			  <font-awesome-icon :icon="faCheck" class="mr-2 mt-1 mb-auto" :style="{ color: checkColor }" />
			  <slot name="bullet-3">
			    <p class="mb-0">Does the app company own your files?<br> and possibly harvest the data from them?</p>
			  </slot>
			</div>
		      </div>
		    </div>
		  </b-col>
		  <b-col
		    cols="12"
		    sm="5"
		    class="m-auto order-1 order-sm-2"
		    >
		    <b-img
		      :src="require('../assets/cuffed.jpg')"
		      fluid
		      />
		  </b-col>
		</b-row>
	      </b-container>
	      <b-container>
		<b-row>
		  <b-col
		    cols="6"
		    offset="2"
		    md="4"
		    offset-md="0"
		    lg="3"
		    class="d-flex mb-md-auto p-3"
		    >
		    <div class="my-auto">
		      <b-img
			:src="require('../assets/photo_hex_01.png')"
			style="height: 82px;"
			/>
		    </div>
		    <div class="my-auto">
		      <div class="pb-3">
			<slot name="top-right-icon">
			  <b-img
			    :src="require('../assets/trinapp_files.png')"
			    style="height: 82px;"
			    />
			</slot>
		      </div>
		      <div>
			<b-img
			  :src="require('../assets/solid_logo_tr.png')"
			  style="height: 100px;"
			  />
		      </div>
		    </div>
		  </b-col>
		  <b-col
		    cols="12"
		    md="8"
		    lg="9"
		    >
		    <div class="text-left font-italic">
		      <slot name="description">
			<h2 class="mb-5">We think you should have 100% ownership and control over your files;</h2>
			<h2>who has access to your files, where they are stored, and what apps you use to access them.</h2>
		      </slot>
		    </div>
		  </b-col>
		</b-row>
	      </b-container>
	    </b-jumbotron>
	  </b-col>
	</b-row>
      </b-container>
      
    </b-col>
  </b-row>
</b-container>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
export default {
    name: "Layout05",
    components: {
	FontAwesomeIcon
    },
    data () {
	return {
            faCheck
        }
    },
    props: {
	checkColor: String
    }
}
</script>
